import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const DeleteButton = ( { id,  title, confirmMessage, deleteCallback, disabled } ) => {
    const [ isModalVisble, setModalVisible ] = useState( false );
    
    const handleDelete = ( ) => {
        if ( deleteCallback ) { deleteCallback( id ); }
        setModalVisible( false );
    };

    const handleCancel = ( ) => {
        setModalVisible( false );
    };

    return (
        <>
            <Button 
                disabled={ disabled }
                type="link"  
                icon={  
                    <DeleteOutlined style={ { color: disabled ? '#c0c0c0' : '#ff4d4f' } }/> 
                }
                onClick={ () => setModalVisible( true ) }
            />  

            { isModalVisble && 
                <Modal
                    open={ isModalVisble }
                    title={ title }
                    onOk={ handleDelete }
                    onCancel={ handleCancel }
                    footer={ [
                        <Button
                            key="back" 
                            onClick={ handleCancel }
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            danger
                            onClick={ handleDelete }
                        >
                            Delete
                        </Button>
                    ] }
                >
                    { confirmMessage }
                </Modal>
            }
        </>
    );
};

export default DeleteButton;
